import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Modal,
  Typography,
  Paper,
} from "@mui/material";

import GuestForm from "./guestInformation";
import TravelPlanForm from "./guestJourney";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const GuestList = () => {
  const [showForm, setShowForm] = useState(false); // Controls whether the form is displayed
  const [selectedGuest, setSelectedGuest] = useState(null); // For modal details
  const [guestData, setGuestData] = useState([]); // Store Guest Form data
  const [journeyData, setJourneyData] = useState(null); // Store Journey Form data
  const [copied, setCopied] = useState(false);
  const userId = localStorage.getItem("userId");
  const linkToCopy = `${BASE_URL}/GuestFormPage/${userId}`;

  const handleViewDetails = (guest) => {
    setSelectedGuest(guest);
  };

  const handleCloseModal = () => {
    setSelectedGuest(null);
  };

  const handleGuestSubmit = (data) => {
    setGuestData(data);
  };

  // Function to update Journey Form Data
  const handleJourneySubmit = (data) => {
    setJourneyData(data);
  };

  useEffect(() => {
    async function FetchData() {
      try {
        const res = await axios.get(
          `${BASE_URL}/api/v1/User/Guest_List/${userId}`
        );

        console.log(res);
        setGuestData(Array.isArray(res.data.guests) ? res.data.guests : []); // ✅ Ensure it's an array
      } catch (error) {
        setGuestData([]); // ✅ Prevents errors if API fails
      }
    }
    FetchData();
  }, []);

  // Function to merge and submit all data

  const handleSubmitAll = async () => {
    if (!guestData || !journeyData) {
      alert("Please submit both forms first and click on Submit button");
      return;
    }

    const finalData = {
      userId: userId, // Ensure this exists
      ...guestData, // Guest details
      ...journeyData, // Journey details
    };

    console.log("Final Merged Data:", finalData);

    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/Guest_List`,
        finalData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      alert("Data submitted successfully!");
      console.log("Response:", response.data);
    } catch (error) {
      console.error("Error submitting data:", error);

      alert(
        `❌ Error: ${error.response?.data?.error || "Failed to submit data"}${
          error.response?.data?.error?.includes("Missing required fields.")
            ? " or please click on all the submit buttons once again."
            : ""
        }`
      );
    }
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(linkToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Hide message after 2 sec
  };

  return (
    <Box sx={{ margin: "80px" }}>
      {/* Toggle between Guest Form and Table */}
      {/* <div className="d-flex  justify-content-between"> */}
      {/* <div className="absolute top-5 left-10 flex items-center gap-3 bg-gray-100 p-3 rounded-md shadow-md">
        <input
          type="text"
          value={linkToCopy}
          readOnly
          style={{paddingTop:"0.5rem", paddingBottom:"0.6rem", width:"180px"}}
          className="border border-gray-300 px-3  rounded-md w-64 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <Button onClick={handleCopy} variant="contained" color="secondary">
          Copy
        </Button>
        {copied && (
          <span className=" font-semibold" style={{ marginLeft:"5px",color: "green" }}>
            Copied!
          </span>
        )}
      </div> */}

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setShowForm(!showForm);
          if (!Array.isArray(guestData)) {
            setGuestData([]); // ✅ Ensures guestData is always an array
            window.location.reload();
          }
        }}
        sx={{ float: "right", marginBottom: 2 }}
      >
        {showForm ? "Back to Guest List" : "Guest Form"}
      </Button>
      {/* </div> */}
      {/* Conditional Rendering */}
      {!showForm ? (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize: "1.5rem" }}>ID</TableCell>
                <TableCell style={{ fontSize: "1.5rem" }}>Guest Name</TableCell>
                <TableCell style={{ fontSize: "1.5rem" }}>
                  No. of Family Members
                </TableCell>
                <TableCell style={{ fontSize: "1.5rem" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {guestData &&
                guestData.map((guest) => (
                  <TableRow key={guest.guest_id}>
                    <TableCell style={{ fontSize: "1.2rem" }}>
                      {guest.guest_id}
                    </TableCell>
                    <TableCell style={{ fontSize: "1.2rem" }}>
                      {guest.guest_name}
                    </TableCell>
                    <TableCell style={{ fontSize: "1.2rem" }}>
                      {guest.family_members?.length || 0}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        onClick={() => handleViewDetails(guest)}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box sx={{ marginTop: 4 }}>
          <GuestForm onSubmit={handleGuestSubmit} />
          <TravelPlanForm onSubmit={handleJourneySubmit} />

          <Button
            variant="contained"
            color="primary"
            className="mt-5"
            onClick={handleSubmitAll}
          >
            Submit All Data
          </Button>
        </Box>
      )}

      {/* Modal for Viewing Guest Details */}
      <Modal open={!!selectedGuest} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
          }}
        >
          {selectedGuest && (
            <>
              {/* Guest Details */}
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  color: "#1976d2",
                  fontFamily: "KaushanScript",
                }}
              >
                Guest Details
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography>
                  <strong>Name:</strong> {selectedGuest.guest_name}
                </Typography>
                <Typography>
                  <strong>Age:</strong> {selectedGuest.age}
                </Typography>
                <Typography>
                  <strong>Gender:</strong> {selectedGuest.gender}
                </Typography>
                <Typography>
                  <strong>Contact:</strong> {selectedGuest.contact}
                </Typography>
                <Typography>
                  <strong>Email:</strong> {selectedGuest.email}
                </Typography>
              </Box>

              {/* Family Members Section */}
              {/* {selectedGuest.family_members?.length > 0 && (
              <>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#1976d2", fontFamily: "KaushanScript" }}>
                  Family Members
                </Typography>
                
                {selectedGuest.family_members.map((member, index) => (
                  <Accordion key={index}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h6">{member.name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography><strong>Age:</strong> {member.age}</Typography>
                      <Typography><strong>Gender:</strong> {member.gender}</Typography>
                      <Typography><strong>Relationship:</strong> {member.relationship}</Typography>
                      <Typography><strong>Contact:</strong> {member.contact}</Typography>
                      <Typography><strong>Email:</strong> {member.email}</Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </>
            )} */}

              <TableContainer
                component={Paper}
                sx={{ boxShadow: 3, borderRadius: "6px", marginTop: "20px" }}
              >
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1976d2" }}>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Age
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Gender
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Relationship
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Contact
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Email
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedGuest.family_members?.length > 0 ? (
                      selectedGuest.family_members.map((member, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#f9f9f9",
                            },
                          }}
                        >
                          <TableCell>{member.name}</TableCell>
                          <TableCell>{member.age}</TableCell>
                          <TableCell>{member.gender}</TableCell>
                          <TableCell>{member.relationship}</TableCell>
                          <TableCell>{member.contact}</TableCell>
                          <TableCell>{member.email}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          sx={{
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "#d32f2f",
                          }}
                        >
                          No Family Members Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Travel Plan */}
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  mt: 3,
                  fontWeight: "bold",
                  color: "#1976d2",
                  fontFamily: "KaushanScript",
                }}
              >
                Travel Plan
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography>
                  <strong>Onward - From:</strong>{" "}
                  {selectedGuest.onward_journey.placeFrom}
                </Typography>
                <Typography>
                  <strong>Onward - To:</strong>{" "}
                  {selectedGuest.onward_journey.placeTo}
                </Typography>
              </Box>

              {/* Return Journey */}
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  mt: 3,
                  fontWeight: "bold",
                  color: "#1976d2",
                  fontFamily: "KaushanScript",
                }}
              >
                Return Journey
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography>
                  <strong>Return - From:</strong>{" "}
                  {selectedGuest.return_journey.placeFrom}
                </Typography>
                <Typography>
                  <strong>Return - To:</strong>{" "}
                  {selectedGuest.return_journey.placeTo}
                </Typography>
              </Box>

              {/* Total People */}
              <Typography
                variant="h6"
                gutterBottom
                sx={{ mt: 3, fontWeight: "bold", color: "#d32f2f" }}
              >
                Total People: {selectedGuest.total_people}
              </Typography>

              {/* Close Button */}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleCloseModal}
                  sx={{
                    textTransform: "none",
                    px: 3,
                    py: 1,
                    borderRadius: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  Close
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </Box>
  );
};
export default GuestList;
